module.exports = __webpack_public_path__ + "img/relacionescolor-gopacsi.b90bc71a.png";